<template>
  <div>

    <h3>Step 4/5</h3>

    <img v-lazy="uploadedImgUrl" height="100" width="100"> <br>

    from previous route => {{$route.query}} <br><br>
    location from previous route [parsed] => {{JSON.parse($route.query.shareSpotLocation)}} <br><br>
<!--
    Spot type => {{$store.state.uploadImage_4.selectedSpotType_uploadImage}}
    <v-select
      v-model="$store.state.uploadImage_4.selectedSpotType_uploadImage"
      label="Spot type"
      chips
      tags
      :items="$store.state.uploadImage_4.spotType_uploadImage"
      :search-input.sync="$store.state.uploadImage_2.qStr_tags_uploadImage"
      @keyup="$store.state.uploadImage_2.qStr_searchThisTag = 'spotType'"
    ></v-select-->

    <!--Anyone can visit this spot => {{$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage}} -->
    <!--v-switch
      label="Anyone can visit this spot"
      v-model="$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage"
    ></v-switch-->

    <button
      @click="goTo_uploadImage_5({
         url: $route.query.url,
         resourceType: $route.query.resourceType,
         publicId: $route.query.publicId,
         //
         createdAt: $route.query.createdAt,
         //
         caption: $route.query.caption,
         emotionalAppeal: JSON.parse($route.query.emotionalAppeal),
         //
         shareSpotLocation: JSON.parse($route.query.shareSpotLocation), //parsed
         hasGeohash: $route.query.hasGeohash,
         //
         spotType: $store.state.uploadImage_4.selectedSpotType_uploadImage,
         anyoneCanVisitThisSpot: $store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage
      })"
    >
      next
    </button>

  </div>
</template>

<script>
  import {mapMutations} from 'vuex'
  import {mapGetters} from 'vuex'
  //
  import uploadImage from '../../mixin/uploadImage'
  //
  export default {
    //
    mixins: [
      uploadImage
    ],
    methods:{
      ...mapMutations([
        'goTo_uploadImage_5'
      ])
    },
    computed:{
      ...mapGetters([

      ])
    },
    created(){
      window.thisOfVueComp = this
    },
    mounted(){
      // this.$store.commit('getSpotTypeSuggestions_fromLocalStorage')
    }
    //
  }
</script>



// WEBPACK FOOTER //
// uploadImage_4.vue?a8df884a